import RadioQuestion from "@components/questions/RadioQuestion";
import SelectQuestion from "@components/questions/SelectQuestion";
import MapCommentQuestion from "@components/questions/MapCommentQuestion";
import TopChoicesQuestion from "@components/questions/TopChoicesQuestion";
import LongTextQuestion from "@components/questions/LongTextQuestion";
import PropTypes from "prop-types";

Question.propTypes = {
  question: PropTypes.object,
};

export default function Question({ question }) {
  switch (question.question_type) {
    case "Radio":
      return <RadioQuestion question={question} />;
    case "Select":
      return <SelectQuestion question={question} />;
    case "Map comment":
      return <MapCommentQuestion question={question} />;
    case "Top choices":
      return <TopChoicesQuestion question={question} />;
    case "Long text":
      return <LongTextQuestion question={question} />;
    default:
      return null;
  }
}
